import styled from "styled-components";

/* Common Create */
export const CreateForm = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
export const FormSplit = styled.div`
  border: 1px solid #4b515b;
  border-width: 1px 0 1px 0;
  margin-bottom: 30px;
  input {
    padding: 10px 12px;
    height: auto;
  }
`;

export const FormRow = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
  &:last-child {
    border-bottom: none;
  }
  &.required-inp {
    input {
      border: 1px solid #ff4040;
    }
    .error-msg {
      font-size: 12px;
      padding: 4px 0 0 12px;
      color: #ff4040;
    }
  }
  .inp-box {
    display: inline-block;
    vertical-align: middle;
  }
  .option {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    color: #191919;
    padding: 0 12px 0 24px;
  }
  .download {
    display: inline-block;
    vertical-align: middle;
    width: 152px;
    text-align: center;
    font-size: 14px;
    color: var(--secondary-500);
    margin-left: 12px;
    padding: 10px 0;
    font-weight: 600;
    border: 1px solid var(--secondary-500);
    border-radius: 5px;
    text-decoration: none;
  }
  /* .warning {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    color: #ff3a3a;
    padding-left: 12px;
  } */
`;
export const FormThead = styled.p`
  display: inline-block;
  vertical-align: middle;
  ${({ width }) => width ? `width: ${width}px;` : "width: 200px;"}
  padding: 0 12px;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  ${({ required }) => required && (
    `&::after {
      content: " *";
      color: #FF5353;
    }`
  )}
`;
export const DefaultVal = styled.div`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  .fixed {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    font-size: 15px;
    color: #262626;
  }
  input {
    text-align: right;
  }
  .kw-inp {
    padding: 10px 40px 10px 10px;
  }

  .unit-inp {
    padding: 10px 30px 10px 10px;
  }
`;
export const OptionInfoCreate = styled.div`
  display: grid;
  ${({ columns }) => columns ? `grid-template-columns: ${columns};` : "grid-template-columns: 3fr 2fr;"}
  justify-content: space-between;
  align-items: center;
  background-color: #f2f3f5;
  border: 1px solid #e5e6e8;
  padding: 15px 24px;
  margin-bottom: 30px;
  p {
    display: inline-block;
    vertical-align: middle;
    font-size: 16px;
    font-weight: 500;
    color: #191919;
  }
`;
export const ButtonArea = styled.div`
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  button {
    padding: 10px 24px;
    text-align: center;
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
    font-size: 14px;
    font-weight: 600;
    color: var(--grey-900);
  }
  a {
    display: inline-block;
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    color: var(--grey-900);
    padding: 12px 40px;
    text-align: center;
    text-decoration: none;
    &:last-child {
      margin-left: 20px;
    }
  }
`;
export const BtnGroup = styled.div`
  width: 1176px;
  margin: 0 auto;
  text-align: right;
  button {
    min-width: 120px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    border: 1px solid var(--primary-500);
    padding: 10px;
    text-align: center;
    &:first-child {
      background-color: transparent;
      color: var(--grey-900);
      margin-right: 12px;
    }
    &:last-child {
      background-color: var(--primary-500);
      color: var(--grey-900);
    }
  }
`;
/* Common Detail */
export const InfoArea = styled.div`
  width: 1176px;
  margin: 0 auto;
`;
export const InfoHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #d5d8de;
  border-width: 0 0 1px 0;
  h1 {
    font-size: 24px;
    color: #191919;
    font-weight: bold;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 20px;
  padding: 12px 0;
  .box {
    width: 100%;
  }
  .tit {
    font-size: 18px;
    margin-bottom: 12px;
  }
  dl {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
    &.total-unit {
      dd {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }
  dt,
  dd {
    display: inline-block;
    vertical-align: middle;
    font-size: 16px;
    color: #191919;
  }
  dt {
    font-weight: 600;
    margin-right: 12px;
  }
  dd {
    font-weight: normal;
  }
`;
export const InfoList = styled.div`
  border: 1px solid #333;
  border-width: 1px 0 1px;
  padding: 12px 0;
  h2 {
    font-size: 18px;
    color: #191919;
    margin-bottom: 12px;
  }
`;
export const ListWrapper = styled.div`
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: ${(props) => props.columns || "repeat(5, minmax(0, 1fr))"};
  gap: ${(props) => props.gap || "20px"};
  align-content: start;
`;
export const InfoListBox = styled.div`
  width: 100%;
  min-width: 0;  
  border: 1px solid 1px #e5e6e8;
  background-color: #f2f3f5;
  border-radius: 12px;
  padding: 15px 20px;
  color: #191919;
  p {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  li {
    font-weight: 600;
  }
  li:first-child {
    font-size: 22px;
  }
  li:last-child {
    text-align: right;
    font-size: 18px;
  }
  ul.control-box {
    li:first-child {
      font-size: 14px;
      color: #8c8c8c;
    }
    li:last-child {
      button {
        font-size: 14px;
        font-weight: bold;
        padding: 4px 20px;
        color: #fff;
        border-radius: 28px;
        // box-shadow: 0 0 6px 0 rgba(69, 255, 65, 0.76);
        // border: solid 1px #63ee4c;
        // background-color: #34e466;
      }
    }
  }
`;
export const CurrentTime = styled.div`
  padding: 30px 0;
  ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
    margin-bottom: 10px;
    li {
      font-size: 18px;
      color: #191919;
    }
    li:first-child {
      font-weight: bold;
    }
    li:last-child {
      text-align: right;
    }
  }
  .progress {
    border-radius: 6px !important;
    height: 22px !important;
  }
  .bg-custom-progressbar {
    background: linear-gradient(90deg, var(--primary-500) 0%, var(--secondary-500) 100%) !important;
  }
`;

/* 전력기기 checkbox && selectbox */
export const Checkbox = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-right: 30px;
  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"] + label {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #d5d8de;
    border-radius: 4px;
    position: relative;
  }
  input[type="checkbox"]:checked + label {
    background: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    border-radius: 4px;
  }
  input:checked + label::after {
    content: "";
    width: 14px;
    height: 10px;
    background-image: url("/images/ctors/icon/checked-icon.png");
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  span {
    display: inline-block;
    vertical-align: middle;
    padding-left: 8px;
    font-size: 14px;
    color: #333;
  }
`;
export const SelectContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 436px;
  border: 1px solid #d5d8de;
  border-radius: 4px;
  .select {
    position: relative;
    width: 100%;
    cursor: pointer;
    p {
      width: 100%;
      padding: 10px 12px;
      background-color: transparent;
      border: 1px solid #fff;
      border-width: 0 0 1px 0;
      text-align: left;
      font-size: 15px;
      font-weight: 500;
      color: #262626;
    }
  }
  .select::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #333;
  }
  .select.disabled {
    background-color: #f8f8f8;
    border-radius: 4px;
    p {
      color: #848484;
    }
  }
  .select.disabled::after {
    border-top: 10px solid #969696;
  }
  .option-container {
    position: absolute;
    top: 50px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #d5d8de;
    border-radius: 5px;
    box-shadow: 0 3px 10px 0 rgba(68, 69, 71, 0.15);
    padding: 8px;
    z-index: 10;

    .option {
      display: block;
      padding: 0;

      &.disabled {
        color: #aaa;
        cursor: not-allowed;
      }

      &.disabled label {
        color: #aaa;
      }

      &:not(.disabled):hover label {
        background-color: #f8f9fe;
      }

      label {
        font-weight: 500;
        text-align: center;
        display: block;
        font-size: 16px;
        color: #191919;
        padding: 10px 12px;
        cursor: pointer;
        text-align: left;
      }

      &:first-child:hover label,
      &:first-child label.selected {
        border-radius: 5px 5px 0 0;
      }

      &:last-child:hover label,
      &:last-child label.selected {
        border-radius: 0 0 5px 5px;
      }
    }
  }
`;
